
import {defineComponent, PropType} from 'vue'
import {CtCatalogue, CtPacking} from '@/models/interfaces/content-type'
import FulfillmentPricing from '@/pages/Channels/components/FulfillmentPricing.vue'
import StoragePricing from '@/pages/Channels/components/StoragePricing.vue'
import PrintPackingSlips from '@/pages/Channels/components/PrintPackingSlips.vue'
import ChannelProducts from '@/pages/Channels/components/ChannelProducts.vue'
import SkuSettingsField from '@/components/SkuSettingsField.vue'
import ChannelSettings from '@/pages/Channels/components/ChannelSettings.vue'
import SkuSettings from '@/pages/Channels/components/SkuSettings.vue'
import SalesChannelSettings from '@/pages/Channels/components/SalesChannelSettings.vue'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import DButton from '@/components/base/DButton.vue'

interface CombinedProducts {
  catalogue_id: string,
  active: boolean,
}

interface ProductState {
  curr: CombinedProducts[],
  prev: CombinedProducts[],
}

export default defineComponent({
  name: 'ChannelDetails',
  props: {
    catalogue: {
      type: Object as PropType<CtCatalogue>,
      required: true,
    },
    activeToggle: {
      type: Boolean,
      default: false,
    },
    packing: {
      type: Array as PropType<Array<CtPacking>>
    },
    readonly: {
      type: Boolean
    }
  },
  components: {
    TrashIcon,
    SalesChannelSettings,
    SkuSettings,
    ChannelSettings,
    SkuSettingsField,
    ChannelProducts,
    PrintPackingSlips,
    FulfillmentPricing,
    StoragePricing,
    DButton,
  },
  emits: ['packing-resolved', 'update:catalogue', 'save:catalogue', 'delete'],
  setup () {
    return {}
  }
})
